import experienceBg from "@/assets/experience-bg.png";

const steps = [
  {
    n: "01",
    title: "Choose the Moment",
    body: "Pick from legendary sports scenarios — kick the field goal, take the shot, make the pass, score the penalty.",
    note: "A growing moment library creates repeat visitation and seasonal content drops.",
  },
  {
    n: "02",
    title: "Enter the Cube",
    body: "Walk into a high-resolution LED chamber surrounded by stadium visuals, crowd noise, pressure, and atmosphere.",
    note: "A standardized room format supports consistent throughput, operations, and future franchise replication.",
  },
  {
    n: "03",
    title: "Become the Highlight",
    body: "Complete the challenge, capture the moment, and leave with a personalized cinematic video package.",
    note: "Highlight videos create premium upsell potential and organic social distribution.",
  },
];

export function Experience() {
  return (
    <section id="experience" className="relative py-32 bg-arena overflow-hidden">
      <div
        aria-hidden
        className="absolute inset-0 bg-cover bg-center opacity-70 pointer-events-none"
        style={{ backgroundImage: `url(${experienceBg})` }}
      />
      <div className="absolute inset-0 bg-gradient-to-b from-background/60 via-background/30 to-background/70 pointer-events-none" />
      <div className="absolute inset-0 bg-background/20 pointer-events-none" />
      <div className="relative mx-auto max-w-7xl px-6">
        <div className="max-w-2xl mb-20">
          <p className="text-xs uppercase tracking-[0.3em] text-primary mb-4">The Experience</p>
          <h2 className="font-display text-4xl sm:text-6xl leading-tight">
            Three steps from fan <br />to <span className="text-gradient-ember">highlight reel.</span>
          </h2>
        </div>
        <div className="grid md:grid-cols-3 gap-px bg-border/60">
          {steps.map((s) => (
            <div key={s.n} className="bg-background/10 backdrop-blur-[2px] p-10 group hover:bg-background/25 transition-colors flex flex-col">
              <div className="font-display text-6xl text-primary/60 group-hover:text-primary transition">{s.n}</div>
              <h3 className="font-display text-2xl mt-6">{s.title}</h3>
              <p className="mt-4 text-foreground/90 leading-relaxed">{s.body}</p>
              <div className="mt-6 pt-6 border-t border-border/60">
                <div className="text-[10px] uppercase tracking-[0.3em] text-primary mb-2">Investor Note</div>
                <p className="text-sm text-muted-foreground leading-relaxed">{s.note}</p>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
